import {
  ActionType,
  IAdditionalSettings,
  IntelligentSelectorSimple,
  SiteSuitabilityResult,
  UrlPattern,
} from "./state-machine";

export enum PageType {
  HOME_PAGE = "home_page",
  SEARCH_RESULTS = "search_results",
  PRODUCT_LIST = "product_list",
  PRODUCT_DETAIL = "product_detail",
  CART = "cart",
  LOGIN = "login",
  CHECKOUT = "checkout",
  CATEGORY_PAGE = "category_page",
  UNKNOWN = "unknown",
}

export interface IUrlPattern {
  regex?: string;
  confidence: number;
  example?: string;
  reasoning?: string;
}

export interface ICartState {
  hasItems: boolean;
  itemCount: number;
  estimatedValue?: string;
  canProceedToCheckout: boolean;
  emptyCartIndicators?: string[];
}

export interface IAvailableActions {
  canSearch: boolean;
  canAddToCart: boolean;
  canGoToCart: boolean;
  canCheckout: boolean;
  canNavigateBack?: boolean;
}

export interface IDiscoveredSelectors {
  searchField?: string;
  addToCartButton?: string;
  addToCartSelectors?: string[];
  skuSelectors?: { type: string; selector: string }[];
  cartNavigation?: string;
  checkoutButton?: string;
  productLinks?: string[];
  cartItemCount?: string;
  cartTotal?: string;
  modalClose?: string;
  cookieAccept?: string;
}

export interface IJourneyAssessment {
  currentPhase:
    | "landing"
    | "product_search"
    | "cart_building"
    | "checkout_prep";
  canSkipToCheckout: boolean;
  needsProductSearch: boolean;
  requiresAuthentication: boolean;
  hasObstacles: boolean;
}

export interface IMerchantContext {
  matchesKnownPatterns: boolean;
  siteStructureType: "standard" | "spa" | "complex" | "unknown";
  checkoutFlowType:
    | "single_page"
    | "multi_step"
    | "guest_available"
    | "login_required";
}

export interface IRecognisePageResponse {
  type: PageType;
  confidence: number;
  metadata: {
    // Standard metadata
    productName?: string;
    productPrice?: string;
    searchQuery?: string;
    category?: string;
    hasAddToCart?: boolean;
    hasSearch?: boolean;
    hasProducts?: boolean;
    productCount?: number;

    // Enhanced metadata
    cartState?: ICartState;
    availableActions?: IAvailableActions;

    discoveredSelectors?: {
      [key in ActionType]?: IntelligentSelectorSimple[];
    };

    urlPatterns?: {
      [key in PageType]?: Array<UrlPattern>;
    };
    journeyAssessment?: IJourneyAssessment;
    merchantContext?: IMerchantContext;
    additionalSettings?: IAdditionalSettings;
    siteSuitability?: SiteSuitabilityResult;
  };
  reasoning: string;
}
